// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Common_hidden__1VtZo","brandText":"Common_brandText__2a0jV","highlightYellow":"Common_highlightYellow__QSHXj","highlightBlue":"Common_highlightBlue__AJLcQ"};